export default class CustomerCity extends HTMLElement {
  async connectedCallback() {
    const prefix = this.getAttribute('prefix') || '';
    // optional: show a loading state
    // this.textContent = '…';

    try {
      const res = await fetch('https://api.dietsmoke.com/v1/location/lookup');
      if (!res.ok) return;

      const data = await res.json();
      if (data.error) return; // not US or other error

      const city = data.city;
      this.textContent = prefix ? `${prefix} ${city}` : city;
    } catch (err) {
      console.error('Location lookup failed:', err);
    }
  }
}
